export const Dictionary = {
  __presentation_1:
    "The site for writers of fantasy books, novels and short stories with more complex plots.",
  __presentation_2:
    "Plotter Studio is a platform created in collaboration with writers for writers.",
  __presentation_3: "Event-based plot writing",
  __presentation_4: "Time order",
  __presentation_5:
    "Keep all the key events of your plot in order by placing them on a timeline. Events can be classified by type, characters involved, keywords and more!",
  __presentation_6: "Control",
  __presentation_7:
    "Check the consistency of the inserted events, so as to avoid plot holes or inconsistencies. Plotter Studio will perform the analysis of all events for you and find potential errors.",
  __presentation_8: "Teamwork",
  __presentation_9:
    "Plotter Studio allows users to invite others to collaborate on the same book, thus allowing professional effectiveness even in a work environment.",
  __presentation_10: "Intuitive interface",
  __presentation_11:
    "Using Plotter Studio has been optimized to be easy to use, so you can focus on your book without having to think about anything else.",
  __presentation_12: "Do you have any questions?",
  __presentation_12_2:
    "The Plotter Studio team is at your disposal to answer all your questions",
  __presentation_13: "Contact us",
  __presentation_14: "Or, you can create an account for free ",
  __presentation_14_2:
    "Upon registration, you get a free month of access to the Mini account to try out the system.",
  __presentation_15: "Professional quality",
  __presentation_16:
    "Plotter Studio is developed and maintained by a group with decades of experience in the IT world, and we guarantee continuous evolutions over time.",
  __footer_about_us: "About us",
  __footer_our_mission: "Our mission",
  __footer_were_are_we_headed: "Were are we headed",
  __footer_privacy: "Privacy Policy",
  __footer_term_of_use: "Terms of Service",
  __footer_services: "Our services",
  __footer_serv_support: "Writers support",
  __footer_serv_teaching: "Teaching",
  __footer_serv_private_solutions: "Private solutions",
  __footer_contact_us: "Contact us",
  __footer_social_media: "Social media",
  __footer_social_facebook: "Facebook",
  __footer_social_twitter: "Twitter",
  __app_for_writers_logo: "The App for Writers",
  __service_support_title: "Technical Support",
  __service_support_desc:
    "Experiencing an issue? Describe what happened and our technical team will get back to you promptly.",
  __service_teaching_title: "Training & Teaching",
  __service_teaching_desc:
    "Want to master our tools? Ask for information about our courses and webinars.",
  __service_private_title: "Private Solutions",
  __service_private_desc:
    "Need dedicated infrastructure? Let's discuss how we can scale your business with custom-tailored solutions.",
  __mission_title: "Empowering the Next Generation of Storytellers",
  __mission_subtitle:
    "Bridging the gap between raw imagination and structured masterpieces.",
  __mission_p1_title: "Taming the Chaos",
  __mission_p1_desc:
    "We help writers overcome the hurdles of consistency and plot holes. By combining advanced AI with expert-crafted tools, we turn the daunting task of writing into a guided journey of creativity.",
  __mission_p2_title: "Mastering Complexity",
  __mission_p2_desc:
    "Large-scale projects can be overwhelming. We provide a controlled environment where complex worlds, intricate timelines, and deep character profiles are easily managed, allowing you to focus on the art of writing.",
  __mission_founder_title: "Built by a Writer, for Writers",
  __mission_founder_desc:
    "I created this platform because I needed it. As a writer struggling to track the thousands of events in my own fantasy saga, I wanted a tool that didn't just store data, but understood the story. This is the workspace I always dreamed of.",
};
